export const BLOG_EDITORIAL_CATEGORIES = [
  "Workers", "News & jobs", "What’s on the market?", "Remote work", "Skills & training", "Industry insights", "Tips & Guides", "Guides",
];
